export default __webpack_public_path__ + "static/media/FacebookIcon.2fc10245.svg";